import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

// необходим для того чтобы задать title т.к. стандартный тэг не имеет html атрибута title
// имеет иструктуру идентичную стандартному тэгу
const tagRender = (props) => {
  const { label, onClose } = props;

  return (
    <span className="ant-select-selection-item" title={label}>
      <span className="ant-select-selection-item-content">{label}</span>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <span
        style={{ fontSize: '16px', fontWeight: 300 }}
        className="ant-select-selection-item-remove"
        onClick={onClose}
      >
        ×
      </span>
    </span>
  );
};

const appendCustom = (values, selectedValue, multiple) => {
  if (!selectedValue) {
    return values;
  }

  const newValues = values.slice();

  if (multiple) {
    selectedValue.forEach((v) => {
      if (newValues.findIndex((arrVal) => arrVal === v) === -1) {
        newValues.push(v);
      }
    });
  } else if (newValues.findIndex((arrVal) => arrVal === selectedValue) === -1) {
    newValues.push(selectedValue);
  }

  return newValues;
};

const sortByRelevance = (values, searchedValue) => {
  let result = [];

  values.forEach((v) => {
    if (v === searchedValue) {
      result = [v, ...result];
    } else {
      result.push(v);
    }
  });

  return result;
};

const preprocessValues = (values, selectedValue, searchedValue, multi) => {
  let valuesVar = values;

  valuesVar = appendCustom(valuesVar, selectedValue, multi);
  return sortByRelevance(valuesVar, searchedValue);
};

const prepareOptions = (values, searchedValue, customizable) => {
  let options = values.map((v) => (
    <Option key={v} value={v}>
      {v}
    </Option>
  ));

  if (customizable && searchedValue && !values.find((v) => v === searchedValue)) {
    options = [
      <Option key={searchedValue} value={searchedValue}>
        {`Create "${searchedValue}"`}
      </Option>,
      ...options,
    ];
  }

  return options;
};

const serialize = (obj) =>
  Array.isArray(obj) ? obj.map((v) => JSON.stringify(v)) : JSON.stringify(obj);

const deserialize = (obj) => (Array.isArray(obj) ? obj.map((v) => JSON.parse(v)) : JSON.parse(obj));

const getMode = (multi, customizable) => {
  if (multi && customizable) {
    return 'tags';
  }

  if (multi) {
    return 'multiple';
  }

  return 'default';
};

class SelectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedValue: undefined,
    };
  }

  render() {
    let { values = [], value } = this.props;
    const {
      customizable = false,
      multi = false,
      useJSON = false,
      style = {},
      className = '',
      allowClear = true,
      placeholder = 'Select a value',
      dropdownStyle = { width: 'auto' },
      onChange,
    } = this.props;

    const { searchedValue } = this.state;

    if (multi && !value) {
      value = [];
    }

    if (useJSON) {
      values = serialize(values);
      value = value && serialize(value);
    }
    // Проверить необходимость сериализации/десериализации!

    values = preprocessValues(values, value, searchedValue, multi);
    const options = prepareOptions(values, searchedValue, customizable);

    return (
      <Select
        allowClear={allowClear}
        placeholder={placeholder}
        showSearch
        style={style}
        value={value}
        className={className}
        mode={getMode(multi, customizable)}
        onSearch={(searchedValueParam) => {
          // This trick is used because otherwise (if setTimeout is omitted)
          // searched value remains in the input after some option have been
          // selected
          setTimeout(() => this.setState({ searchedValue: searchedValueParam }), 1);
        }}
        onChange={(v) => {
          let vVar = v;
          // We need this call because in both tags and multiple mode onSearch isn't called
          // when the value is selected (opposite to the behaviour in case of default mode)
          if (searchedValue) {
            this.setState({ searchedValue: undefined });
          }

          vVar = vVar && useJSON ? deserialize(vVar) : vVar;

          onChange(vVar);
        }}
        dropdownMatchSelectWidth
        dropdownStyle={dropdownStyle}
        getPopupContainer={(triggerNode) => triggerNode}
        virtual={false}
        tagRender={tagRender}
      >
        {options}
      </Select>
    );
  }
}

export default SelectComponent;
